<script setup lang="ts">
import DebugTools from '@components/debugtools/DebugTools.vue'
import { setYupLocales } from '@core/plugins/plugin-yup.ts'
import { Toaster } from 'vue-sonner'
import 'primeicons/primeicons.css'

const { hasToken } = useAuthStore()

const { t } = useI18n()
const globalLoading = ref(false)

useTheme()

setYupLocales(t)

const themeColor = computed(() => {
  return '#2D95A4'
})

useHead({
  title: t(`meta.${appType.value}.title`),
  meta: [
    { name: 'description', content: t(`meta.${appType.value}.description`) },
    {
      name: 'theme-color',
      content: themeColor,
    },
  ],
  link: [
    {
      rel: 'icon',
      type: 'image/ico',
      href: '/favicon.ico',
    },
  ],
})
if (hasToken.value) {
  refreshToken()
    .finally(() => {
      globalLoading.value = false
    })
}
</script>

<template>
  <div class="bg-slate-100 dark:bg-slate-700" style="min-height: 100vh;">
    <Toaster :theme="isDark ? 'dark' : 'light'" :visible-toasts="9" rich-colors position="bottom-right" :expand="true" />
    <Toast />
    <ConfirmDialog />
    <DebugTools />
    <RouterView />
  </div>
</template>
